import React, {Component} from 'react';
import './styles/Divider.css';
import {GoogleApiWrapper, Map, Marker} from 'google-maps-react';

export class MapContainer extends Component {
    render() {
        return (

            <Map google={this.props.google}
                 initialCenter={{
                     lat: -33.8888005,
                     lng: 151.1922041
                 }}
                 zoom={15}
                 onClick={this.onMapClicked}>
                <Marker onClick={this.onMarkerClick}
                        name={'Current location'}/>
            </Map>
        );
    }
}

export default GoogleApiWrapper({
    apiKey: ("AIzaSyBysB3D0YYTTGYG4qqIahXUvXTrTBbCN00")
})(MapContainer)